import { FOLLOW_USER, UNFOLLOW_USER } from "shared/api";
import { AsyncButton, Icon, MenuButton, Button } from "shared/react";
import { callAPI, getCallAPIWithNotice } from "../util/api.js";
import { useFollowedData } from "../util/data.js";

/** Follow/unfollow button shown on a user's profile. */
export function FollowButton({ followed, mods = "" }: { followed: string; mods?: string | undefined }): React.ReactElement | null {
	const { status } = useFollowedData(followed);
	if (status === "you") {
		return null;
	} else if (status === "approved") {
		return (
			<MenuButton mods={`${mods} button-success`} menu={<FollowMenu followed={followed} />}>
				<Icon icon="tick" /> <span>Following</span>
			</MenuButton>
		);
	} else if (status === "requested") {
		return (
			<MenuButton mods={mods} menu={<FollowMenu followed={followed} />}>
				<Icon icon="snooze" /> <span>Requested</span>
			</MenuButton>
		);
	} else {
		return (
			<AsyncButton mods={mods} onClick={() => callAPI(FOLLOW_USER, followed)}>
				<Icon icon="tick" /> <span>Follow</span>
			</AsyncButton>
		);
	}
}

export function FollowMenu({ followed }: { followed: string }): React.ReactElement {
	const { status } = useFollowedData(followed);
	return (
		<nav>
			{status === "you" ? null : status === "approved" || status === "requested" ? (
				<Button onClick={getCallAPIWithNotice(UNFOLLOW_USER, followed)}>Unfollow profile</Button>
			) : (
				<Button onClick={getCallAPIWithNotice(FOLLOW_USER, followed)}>Follow profile</Button>
			)}
		</nav>
	);
}
